import {createAction} from 'redux-act';

export const SAVE_DATA = createAction('storeAppearance/SAVE_DATA');
export const SAVE_DATA_SUCCESS = createAction(
  'storeAppearance/SAVE_DATA_SUCCESS'
);
export const SET_LOADING = createAction('storeAppearance/SET_LOADING');

export const GET_EMAIL_MARKETING_TRIAL_DATE = createAction(
  'storeAppearance/GET_EMAIL_MARKETING_TRIAL_DATE'
);
export const GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS = createAction(
  'storeAppearance/GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS'
);
